import { useLocation, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { ComplianceBadge } from "@/components/ComplianceBadge";
import { LoyaltyRecap } from "@/components/LoyaltyRecap";

export default function OrderConfirm() {
  const { state } = useLocation();
  const order = state?.order;
  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <div className="border border-[var(--line)] bg-[var(--paper-2)] rounded-md p-8">
        <CheckCircle2 className="h-10 w-10 text-[var(--olive)]" strokeWidth={1.6} />
        <div className="eyebrow mt-4">Order received</div>
        <h1 className="h-display text-4xl mt-2">Thank you.</h1>
        {order ? (
          <>
            <div className="mt-3 font-mono text-lg" data-testid="order-number">{order.order_number}</div>
            <div className="mt-2"><ComplianceBadge kind="order_status" value={order.status} /></div>
            <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">
              Your order is queued for compliance review and will ship in 1–2 business days. You will be notified by email when it leaves the warehouse.
            </p>
          </>
        ) : (
          <p className="mt-4 text-[var(--ink-soft)]">Your order is being processed.</p>
        )}

        <div className="mt-6">
          <LoyaltyRecap order={order} />
        </div>

        <div className="mt-6 flex gap-3">
          <Link to="/account/orders" className="btn-primary" data-testid="view-orders-link">View my orders</Link>
          <Link to="/shop" className="btn-outline">Continue shopping</Link>
        </div>
      </div>
    </div>
  );
}
